import React, { PureComponent } from 'react';
import {
  StyleSheet,
  View,
  Text,
  ScrollView,
} from './components/base_components';
import LinkTextButton from './components/buttons/link_text_button';

const styles = StyleSheet.create({
  notFoundScreen: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'transparent',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
  },
  scroller: { flex: 1, alignSelf: 'stretch', flexDirection: 'column' },
  scrollInner: {
    paddingLeft: '3em',
    paddingRight: '3em',
    paddingTop: '1em',
    paddingBottom: '5em',
    alignSelf: 'stretch',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    overflowY: 'scroll',
  },
  headerText: {
    marginTop: '1em',
    color: '#222',
    fontSize: '1.2em',
    fontWeight: 'bold',
  },
});

type Props = {};
type State = {};

export default class notFoundScreen extends PureComponent<Props, State> {
  render() {
    return (
      <View style={styles.notFoundScreen}>
        <ScrollView
          style={styles.scroller}
          contentContainerStyle={styles.scrollInner}
        >
          <Text style={styles.headerText}>Page not found</Text>
          <LinkTextButton url='/' text='Go Home' />
        </ScrollView>
      </View>
    );
  }
}
